import Dispute from "./Dispute";

export default Dispute;
